import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { RecaptchaComponent } from 'ng-recaptcha';
import { AppConfigsService } from '../../../config/app-configs.service';
import { ErrorsHandlerService } from '../../cardholders-core/services/errors.handler.service';
import { LoggerService } from '../../cardholders-core/services/logger.service';
import { RecaptchaV2ResetRequiredMode } from '../../enums/recaptcha_V2-mode.enums';
import { RecaptchaHelperService } from '../../services/recaptcha-helper.service';

@Component({
    selector: 'app-recaptcha_V2',
    templateUrl: './recaptcha_V2.component.html',
    styleUrls: ['./recaptcha_V2.component.scss']
})
export class Recaptcha_V2Component implements OnInit {
    recaptchaSiteKey: string;

    @Input() mode: RecaptchaV2ResetRequiredMode = RecaptchaV2ResetRequiredMode.ApiOnly;
    @Input() formValidationErrorEvent: EventEmitter<void>;
    @Input() apiExecutedEvent: EventEmitter<void>;

    @ViewChild('captchaRef') captchaRef: RecaptchaComponent;

    @Output() resolved = new EventEmitter<string>();

    @Input() execute: EventEmitter<void>;

    enableRecaptcha: boolean;

    constructor(
        private appConfigs: AppConfigsService,
        private errorHandler: ErrorsHandlerService,
        private logger: LoggerService,
        private recaptchaHelper: RecaptchaHelperService
    ) {
        this.recaptchaSiteKey = this.appConfigs.appConfigs.recaptchaSiteKey;
        this.enableRecaptcha = this.recaptchaHelper.getIsenableRecaptcha();
    }

    ngOnInit() {
        const errors = this.validateInput();
        if (errors.length > 0) {
            this.logger.error(
                `RecaptchaV2 requires next events to be reseted so it won't be expireded: [${errors.join(',')}].`
            );
            this.errorHandler.redirectToLoginPage.next();
            throw new Error(
                `RecaptchaV2 requires next events to be reseted so it won't be expireded: [${errors.join(',')}].`
            );
        }
        this.formValidationErrorEvent?.subscribe(_ => {
            this.resetRecaptcha();
        });
        this.apiExecutedEvent?.subscribe(_ => {
            this.resetRecaptcha();
        });
        this.execute?.subscribe(_ => {
            this.executeRecaptcha();
        });
    }

    validateInput(): string[] {
        const errors: string[] = [];
        if (this.mode === RecaptchaV2ResetRequiredMode.FormAndApi) {
            if (this.formValidationErrorEvent === null || this.formValidationErrorEvent === undefined) {
                errors.push('formValidationErrorEvent - on form validation error');
            }
            if (this.apiExecutedEvent === null || this.apiExecutedEvent === undefined) {
                errors.push('apiExecutedEvent - on after api call (both successed of failed)');
            }
        } else if (
            this.mode === RecaptchaV2ResetRequiredMode.ApiOnly &&
            (this.apiExecutedEvent === null || this.apiExecutedEvent === undefined)
        ) {
            errors.push('apiExecutedEvent - on after api call (both successed of failed)');
        }
        if (this.execute === null || this.execute === undefined) {
            errors.push('execute - on click to execute recaptcha component');
        }
        return errors;
    }

    resolvedCaptcha(captchaResponse: string) {
        this.resolved.emit(captchaResponse);
    }

    private resetRecaptcha(): void {
        this.captchaRef.reset();
    }

    private executeRecaptcha(): void {
        this.enableRecaptcha ? this.captchaRef.execute() : this.resolvedCaptcha(null);
    }
}
